import { store } from "../main";

const toast = {
    initialized: false,
    toastQueue: [],
    defaultDuration: 3000,
    toastRunning: false,

    init() {
       //this.runTestToasts()
    },
    async runTestToasts(){
        await new Promise(resolve => setTimeout(resolve, 1000));
        this.addToast({
            type: "card",
            cardImage: "./assets/imgs/toast-att.png",
            title: "Presented by AT&T",
            subtitle: "Charlotte Motor Speedway"
        })
        await new Promise(resolve => setTimeout(resolve, 1000));
        this.addToast({
            type: "minimal",
            iconImage: "./assets/imgs/toast-toyota-icon.png",
            title: "Presented by Toyota"
        })
    },
    addToast(toast, duration = this.defaultDuration){
        toast.duration = duration;
        this.toastQueue.push(toast);

        if(!this.toastRunning){
            this.runToasts();
        }
    },
    async runToasts(){
        this.toastRunning = true;

        while(this.toastQueue.length > 0){
            let currentToast = this.toastQueue.shift();
            currentToast.timeStart = Date.now();
            console.log("pushing toast to screen")
            console.log(currentToast)
            store.commit("currentToast", currentToast);
            await new Promise(resolve => setTimeout(resolve, currentToast.duration));
            store.commit("currentToast", null);
            await new Promise(resolve => setTimeout(resolve, 500));
        }
        
        this.toastRunning = false;
    }
};

export default toast;
